<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-0 content-block-head">
      <div class="col p-2">
        @if (asset.registration !== "") {
          <h4>Asset Register for {{asset.registration}}</h4>
        }
        @if (asset.registration === "") {
          <h4>New Asset</h4>
        }
      </div>
    </div>
    @if (this.asset.id !== -1) {
      <app-audit-line [data]='this.asset'></app-audit-line>
    }
    <div class="row p-3">
      <div class="col content-block">
        <app-asset-form [vehicle]='this.asset' [formSettings]='this.formSettings' [linkedAssets]='this.linkedAssets' [allowLink]='true'></app-asset-form>
      </div>
    </div>



    <div class="row">
      <div class="col content-block btn-group p-3">
        <button class='btn btn-success' (click)='save()'>Save</button>
        <button class='btn btn-danger' (click)='cancel()'>Cancel</button>
      </div>
    </div>
  </div>
</div>
